import { toMoment } from 'api/helpers';

export default class PromotionCategory {
	id = 0;
	name = '';
	end_date = null;

	constructor(item) {
		this.id = item.Id;
		this.name = item.Name;
		this.end_date = toMoment(item.EndDate);
	}
}



// WEBPACK FOOTER //
// ./src/api/models/PromotionCategory.js